import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a href='https://www.instagram.com/aniruddhahahah/' className='link footer__link'>
      Created By Ani in Pune
    </a>
  </footer>
)

export default Footer
